<div class="row justify-content-center mt-5">
  <div class="col-12 col-md-8 col-lg-6">
    <div class="card">
      <div class="card-body text-center p-5">
        <div class="mb-4">
          <i class="bi bi-envelope-check" style="font-size: 4rem; color: #3b82f6;"></i>
        </div>
        <h2 class="card-title mb-4">Check Your Email</h2>
        <p class="card-text mb-4">
          Thank you for registering! We've sent a confirmation email to your inbox.
        </p>
        <p class="card-text mb-4">
          Please click the confirmation link in the email to verify your account and complete your registration.
        </p>
        <div class="alert alert-info" role="alert">
          <strong>Important:</strong> You must confirm your email address before you can log in to your account.
        </div>
        <p class="text-muted mt-4">
          Didn't receive the email? Check your spam folder or <a href="mailto:kingdombrothersonline@gmail.com">contact support.</a>
        </p>
      </div>
    </div>
  </div>
</div>
